export interface ItemContainerRef {
  current: ItemContainer;
}

export interface ItemContainer {
  unit?: string;
  select(text: Maybe<string>, unit?: string): void;
  onItemRemoved(text: string): void;
}
